export default "__VITE_ASSET__8102ce88__"